import React, { Component } from 'react';

export default class CompletedItem extends Component {
    constructor(props){
        super(props);

        this.state = {
            opened: false
        };
    }
    toggleData() {
        this.setState({
            opened: !this.state.opened
        });
    }
    render() {
        let rowStyle = {width: '100%', margin: '0'};
        let dateRaw = this.props.order.date;
        let dateObj = new Date(dateRaw);
        let monthIndex = parseInt(dateObj.getMonth()) + 1;
        let dateString = dateObj.getDate() + '/' + monthIndex + '/' + dateObj.getFullYear();
        console.log("dateString: " + dateString);
        return (
            <div>
            <table className={this.state.opened ? 'line-item-active line-table' : 'line-table'}>
                <tr className="line-item" onClick={this.toggleData.bind(this)}>
                    <td>{dateString}</td>
                    <td>{this.props.order.user_email}</td>
                    <td>NOK {this.props.order.totalProductsPrice},-</td>
                    <td>{this.props.order.status}</td>
                    <td>{this.props.order.receipt_number}</td>
                    <td><div className="show-details">Details</div></td>
                </tr>
            </table>
                {this.state.opened ? (
                    <div style={rowStyle} className="item-data row">
                        <div className="desktop-6 tablet-6 mobile-3">
                            <ul>
                                <li><span>Restaurant</span>{this.props.restaurantName}</li>
                                <li><span>Status</span>{this.props.order.status}</li>
                                <li><span>Customer</span>{this.props.order.user_email}</li>
                                <li><span>Transaction ID</span>{this.props.order.transaction_ref}</li>
                                {this.props.order.phone_number ? (
                                    <li><span>Phone Number</span>{this.props.order.phone_number}</li>
                                ) : ('')}
                                <li><span>Total Price</span>NOK {this.props.order.totalProductsPrice},-</li>

                            </ul>
                        </div>
                        <div className="desktop-6 tablet-6 mobile-3">
                            <ul>
                                <li><span>Order Items</span>
                                    {this.props.order.order.map((orderItem, index) => (
                                        <p> {orderItem.count} x {orderItem.dish_name}</p>
                                        )
                                    )}
                                </li>

                            </ul>
                        </div>
                    </div>
                ) : ('')}

            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/Dashboard/CompletedItem.js